<script>
    export default {
        name: "ProductTypographyVideoItem",
        props: {
            videoItem: Object,
        },
        computed: {
            urlVideo() {
                return `https://i.ytimg.com/vi/${this.videoItem.videoId}/hqdefault.jpg`;
            },
            createId() {
                return this.videoItem.videoId + "-player";
            },
        },
        methods: {
            loadVideo() {
                this.$emit("load-video", {
                    videoId: this.videoItem.videoId,
                    id: this.createId,
                });
            },
        },

        // TODO: остьалось дописать до vimeo и facebook
    };
</script>

<template>
    <div class="product-typography-video-item" @click="loadVideo">
        <div :id="createId" class="product-typography-video-item__wrapper">
            <img class="swiper-lazy" :data-src="urlVideo" alt="" />
            <button class="product-typography-video-item__button outline"></button>
            <div class="swiper-lazy-preloader">
                <preloader :show="true" lg-size></preloader>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .product-typography-video-item {
        padding-top: 56.25%;

        &.swiper-slide {
            height: auto;
        }

        img {
            &.swiper-lazy-loaded {
                & + .product-typography-video-item__button {
                    opacity: 1;
                }
            }
        }
    }

    .product-typography-video-item__wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: block;

        img {
            @include box(100%);
            object-fit: cover;
        }
    }

    .product-typography-video-item__button {
        opacity: 0;
        @include center-absolute(0);
        margin: auto;
        width: 68px;
        height: 48px;
        background-image: url("/static/icons/youtube.svg");
        background-size: contain;
        transition: 0.3s ease-in-out opacity;
    }
</style>
